/**
 * Trunnion AI - Application Shell
 * Main layout with classification banners, top nav, sidebar, and content area.
 */

import { Outlet } from 'react-router-dom';
import { ClassificationBanner } from './ClassificationBanner';
import { TopNav } from './TopNav';
import { Sidebar } from './Sidebar';
import { Breadcrumbs } from './Breadcrumbs';
import { CommandPaletteProvider } from '@/components/command-palette/CommandPaletteProvider';
import { TourProvider } from '@/components/onboarding/TourProvider';

import { PageErrorBoundary } from '@/components/error/PageErrorBoundary';
import { SkipNavigation } from '@/components/a11y/SkipNavigation';

export function AppShell() {
  return (
    <CommandPaletteProvider>
      <TourProvider>
      <div className="flex h-screen flex-col overflow-hidden">
        {/* Skip Navigation for Accessibility */}
        <SkipNavigation />

        {/* Top Classification Banner */}
        <ClassificationBanner position="top" />

        {/* Top Navigation */}
        <TopNav />

        {/* Breadcrumb Navigation */}
        <Breadcrumbs />

        {/* Main Content Area */}
        <div className="flex flex-1 overflow-hidden">
          {/* Sidebar */}
          <Sidebar />

          {/* Page Content */}
          <main id="main-content" role="main" className="flex-1 overflow-auto bg-trunnion-slate-950 p-6">
            <PageErrorBoundary>
              <Outlet />
            </PageErrorBoundary>
          </main>
        </div>

        {/* Bottom Classification Banner */}
        <ClassificationBanner position="bottom" />
      </div>
      </TourProvider>
    </CommandPaletteProvider>
  );
}
